module.exports = __webpack_public_path__ + "static/media/Service1image.3fa7bd35.svg";